import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MenuConfigService } from "./menu-config.service";
@Injectable({
  providedIn: "root"
})
export class MenuHorizontalService {
  // Public properties
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  /**
   * Service constructor
   *
   * @param menuConfigService: MenuConfigService
   */
  constructor(private menuConfigService: MenuConfigService) {
    this.loadMenu();
  }

  /**
   * Load menu list
   */
  loadMenu() {
    // get menu list
    const menuItems: any[] = this.menuConfigService.getMenus().header.items;
    this.menuList$.next(menuItems);
  }
}
